module.exports = __webpack_public_path__ + "static/media/visited_check_large.8a32e78d.png";